import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import HeaderNavPage from "./component/HeaderNav/HeaderNavPage";
import FooterNav from "./component/FooterNav/index";
import DrawerMenu from "./component/DrawerMenu/DrawerMenu";
import WaiterRequest from "./pages/WaiterRequestPage/WaiterRequest";
import { useDispatch, useSelector } from "react-redux";
import useAvailabilityRefresh from "./Utills/useAvailabilityRefresh";

const ProtectedLayout = ({ children }) => {
  const { restaurant, id, table } = useParams();
  useAvailabilityRefresh(id);
  //const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const user = useSelector((state) => state?.user.user);
  const reduxisGuest = useSelector((state) => state?.user.isGuest);
  const waiterRequest = useSelector((state) => state?.user.waiterRequest);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showWaiterPopup, setShowWaiterPopup] = useState(false);
  const packageType = sessionStorage.getItem("packageType");
  const isGuest = packageType === "catelog" || table === "cat";
  //const isGuest = reduxisGuest === true || localStorage.getItem("isGuest") === "true";

  useEffect(() => {
    // close waiter popup on success
    console.log("waiterRequest useEffect", waiterRequest.waiterRequest);
    if (waiterRequest?.waiterRequest?.requestId) {
      console.log("waiterRequest useEffect if", waiterRequest.waiterRequest);
      setShowWaiterPopup(false);
    }
  }, [waiterRequest?.waiterRequest?.requestId]);
  return (
    <>
      {!(user || isGuest) && (
        <Navigate to={`/${restaurant}/${id}/${table}`} replace />
      )}
      {/* Header */}
      {isGuest !== true && (
        <HeaderNavPage onMenuClick={() => setOpenDrawer(true)} />
      )}

      {/* Page Content */}
      <div>{children}</div>

      {/* Drawer */}
      <DrawerMenu isOpen={openDrawer} onClose={() => setOpenDrawer(false)} />

      {/* Waiter Popup */}
      {showWaiterPopup && (
        <WaiterRequest
          isOpen={showWaiterPopup}
          onClose={() => setShowWaiterPopup(false)}
        />
      )}

      {/* Footer */}
      {isGuest !== true && (
        <FooterNav onWaiterClick={() => setShowWaiterPopup(true)} />
      )}
    </>
  );
};

export default ProtectedLayout;
